export default __webpack_public_path__ + "static/media/saint-pierre-sur-dives9.56c09ca2.jpg";